import { toFolder } from '../mappers/folder';
export const parseFolders = res => ({
  ...res,
  data: (res.data.items || []).map(toFolder)
});